(() => {
  if (customElements.get('recommended-for-you')) return;
  class RecommendedForYou extends HTMLElement {
    static select(candidates, currentId, random = Math.random) {
      const pools = ['silver', 'gold'].map((group) => {
        const seen = new Set();
        const items = candidates.filter((item) => {
          if (item.group !== group || item.id === currentId || seen.has(item.id)) return false;
          seen.add(item.id);
          return true;
        });
        const priority = items.filter((item) => item.priority).sort((a, b) => a.priority - b.priority);
        const rest = items.filter((item) => !item.priority);
        for (let i = rest.length - 1; i > 0; i--) {
          const j = Math.floor(random() * (i + 1));
          [rest[i], rest[j]] = [rest[j], rest[i]];
        }
        return [...priority, ...rest];
      });
      let best = [];
      const fill = (selected, slot) => {
        if (selected.length > best.length) best = selected;
        if (slot === 4) return selected;
        for (const item of pools[Math.floor(slot / 2)]) {
          if (selected.some((entry) => entry.id === item.id)) continue;
          const result = fill([...selected, item], slot + 1);
          if (result) return result;
        }
        return null;
      };
      const selected = fill([], 0);
      if (!selected) {
        best = [];
        for (const pool of pools) {
          best.push(...pool.filter((item) => !best.some((entry) => entry.id === item.id)).slice(0, 2));
        }
      }
      return (selected || best).sort((a, b) => Number(Boolean(b.priority)) - Number(Boolean(a.priority)));
    }
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const candidates = [...this.querySelectorAll('template[data-coin-group]')].map((template) => ({
        id: template.dataset.productId,
        group: template.dataset.coinGroup,
        priority: Number(template.dataset.priority) || 0,
        template
      }));
      const selected = RecommendedForYou.select(candidates, this.dataset.currentProduct);
      const grid = this.querySelector('.collection-carousel__track');
      grid.replaceChildren(...selected.map((item) => item.template.content.cloneNode(true)));
      const carousel = this.querySelector('collection-product-carousel');
      if (carousel?.track) carousel.update();
      const notice = this.querySelector('.recommended-coins__notice');
      if (notice) notice.hidden = selected.length === 4;
      if (!selected.length && !notice) this.hidden = true;
    }
  }
  customElements.define('recommended-for-you', RecommendedForYou);
})();
